export default "__VITE_ASSET__DYinpdDT__"